export default __webpack_public_path__ + "images/CsvIcon.4e459fe34c094bc67075521b592449dc.jpeg";